import { render, staticRenderFns } from "./tinkTos.vue?vue&type=template&id=58909808"
import script from "./tinkTos.vue?vue&type=script&lang=js"
export * from "./tinkTos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports